<template>
  <div class="privacy-policy">
    <NavbarComponent />

    <!-- ======= Breadcrumbs ======= -->
    <div
      class="breadcrumbs d-flex align-items-center"
      style="background-image: url('assets/img/ourservice.jpg')"
    >
      <div
        class="container position-relative d-flex flex-column align-items-center"
      >
        <h2>{{ $t("privacy.heading") }}</h2>
        <ol>
          <li>
            <a href="/">{{ $t("home") }}</a>
          </li>
          <li>{{ $t("privacy.heading") }}</li>
        </ol>
      </div>
    </div>
    <!-- End Breadcrumbs -->

    <main class="policy-content">
      <h1>{{ $t("privacy.heading") }}</h1>
      <p class="intro">{{ $t("privacy.intro") }}</p>

      <section
        v-for="(section, key) in $tm('privacy.sections')"
        :key="key"
        class="policy-section"
        style="margin: 0 !important; padding: 0 !important"
      >
        <h2>{{ section.title }}</h2>
        <ul>
          <li v-for="(point, i) in section.points" :key="i">
            {{ point }}
          </li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import NavbarComponent from "@/components/NavbarComponent.vue";

export default {
  name: "PrivacyPolicy",
  components: { NavbarComponent },
  watch: {
    "$i18n.locale": {
      handler() {
        this.updateMeta();
      },
      immediate: true,
    },
  },
  methods: {
    updateMeta() {
      const title = this.$t("privacy.title");
      const description = this.$t("privacy.meta");

      document.title = title;

      let meta = document.querySelector("meta[name='description']");
      if (meta) {
        meta.setAttribute("content", description);
      } else {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        meta.setAttribute("content", description);
        document.head.appendChild(meta);
      }
    },
  },
};
</script>

<style scoped>
.privacy-policy {
  background: var(--color-background);
  color: var(--color-default);
  font-family: "Cairo", sans-serif;
}

.policy-content {
  max-width: 900px;
  margin: 2rem auto;
  padding: 2rem;
}

.policy-content h1 {
  color: var(--color-primary);
  margin-bottom: 1rem;
  text-align: center;
}

.policy-section h2 {
  color: var(--color-secondary);
  margin: 1.5rem 0 0.75rem; /* reduced spacing */
}

.policy-section ul {
  list-style: disc;
  padding-left: 1.5rem;
  margin: 0.5rem 0 0.5rem; /* tighter spacing above/below */
}

.policy-section li {
  margin-bottom: 0.3rem; /* compact list item spacing */
}

.intro {
  margin-bottom: 2rem;
  text-align: center;
}
</style>
